/**
 * Build a ordered Metadata dictionary using Sections and its Controls.
 * MAZ - 7-Ago-2020
 * 
 * See: `metadata-doc.md`
 */
import { is, remapTypes, isVisibleType } from './types'
import { cloned } from '@/helpers'

export function buildMetadata(form) {

  let meta = {
    sections: [],
    dictionary: {}
  }

  if (!form) return meta;

  for (var k=0; k < form.sections.length; k++) {

    let section = form.sections[k];
    section.type = remapTypes(section.type);

    let controls = [];
    for (var j=0; j < section.controls.length; j++) {
      
      let control = section.controls[j] ;

      let normalized = normalizedControl(section, control);
      normalized.parent = k; 

      // add to Dictionary
      meta.dictionary[control.property] = normalized ;

      // add to Controls array
      controls.push(normalized)
    }

    let sectionOptions = cloned(section);
    delete sectionOptions['controls'];

    const normalizedSection = {
      property: section.property,
      type: section.type,
      label: section.label,
      visible: isVisibleType(section.type) && !!section.visible,
      options: sectionOptions,
      controls: controls // all the section normalizedControls
    }
    
    // add to Dictionary
    meta.dictionary[normalizedSection.property] = normalizedSection ;
    
    // add to Sections array, but 
    // sections are not sorted
    meta.sections.push(normalizedSection)
  }

  return meta;
}


function hasDomain(type, control) {
  /**
   * Defines the data domain for this field if it applies.
   * The data domain is the full set of values valid for this field.
   * It only applies to OPTION and ITEM because the domain
   * for other types is infinite or does not matter.
   */
  if (type === is.OPTION_FIELD) { 
    // the Dataset for an OptionField is the set of Codes
    // from where the values will be selected.
    let opts = {}
    control.values.map((v, j) => {
      opts[v] = control.options[j]
    })
    return opts ;
  }
      
  if (type === is.ITEM_FIELD) {
    // the Dataset for a ItemField is the List from 
    // where the items will be selected.
    return {
      list_id: control.associated_list
    }
  }

  return null;
} 


function normalizedControl(section, control) {
  /**
   * Normalizes the Control so they are more consistent for all types,
   * but in options there must remain specific control attributes.
   */
  const retyped = remapTypes(control.type);

  const ct = {
    parent: null,
    section: section.property,
    property: control.property,
    alias: control.alias,
    type: retyped,
    label: control.label,
    visible: isVisibleType(control.type) && !!control.visible,
    hint: control.hint,
    domain: hasDomain(retyped, control),
    options: null
  }

  let options = cloned(control);
  delete options['property'];
  delete options['alias'];
  delete options['type'];
  delete options['label'];
  delete options['hint'];
  delete options['visible'];

  ct.options = options;

  return ct;
}